import React from "react";
import { useNacLocation } from "../../hooks/useNacLocation";
import NotFoundPage from "./NotFoundPage";

/**
 * Loads chilren until isPageNotFound is set in the location state. Then it loads
 * the NotFoundPage component.
 * @param {object} props
 * @param {object} props.children - The children to render if not a 404 page
 * @returns {JSX.Element} - The NotFound component
 */
const NotFound = ({ children }) => {
    const { state: { isPageNotFound } = {} } = useNacLocation();
    return isPageNotFound ? <NotFoundPage /> : children;
};

export default NotFound;
